import api from '@/shared/api/api';
import { TestRunCreateDTO, TestRunListResponseDTO } from '@/shared/api/gen/data-contracts';
import { useFetch } from '@/shared/hooks/useFetch';
import useModals from '@/shared/hooks/useModal';
import LeftSideModal from '@/shared/ui/Modals/LeftSideModal/LeftSideModal';
import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import TestRunForm from '../test_runs/form/TestRunForm';
import { AdminLayout } from '@/components/Layout/Layout';
import SideBar from '@/components/SideBar/SideBar';
import ProjectSidebar from './components/ProjectSidebar';
import { DataGrid } from '@/components/DataGrid/DataGrid';
import { EditButton, RecordField, TextField } from '@/shared/ui/Fields/Fields';
import Button from '@/shared/ui/Buttons/Button';
import TestRunsDatagrid from './components/test_runs/TestRunsDatagrid';
import { FlexRow } from '@/shared/ui/Layouts/Flex';
import TestRunDetailGrid from './components/test_runs/TestRunDetailGrid';

type Props = {}

function ProjectTestRunsManage({}: Props) {
    const {openModal, closeModal} = useModals();
    const { projectID } = useParams();
    const navigate = useNavigate();
    const { data: testRuns, refresh: refreshTestRuns } = useFetch<TestRunListResponseDTO[]>(
        () => api.test_runs.getTestRunApiTestRunsGet({project_ref: Number(projectID)}),
        [], [], { autoRefresh: true, refreshTiming: 80 }
    );
    const [activeTestRun, setActiveTestRun] = useState<number | null>(null)
    const createTestRun = async (data: TestRunCreateDTO) => {
        await api.test_runs.createTestRunApiTestRunsPost(data)
        closeModal()
        refreshTestRuns()
    }
    const openTestRunCreationForm = () => {
        openModal(
            <LeftSideModal>
                <TestRunForm 
                    onSubmit={createTestRun} 
                    defaultData={{project_ref: Number(projectID)}}
                    projectID={Number(projectID)} 
                    onCancel={closeModal}
                />
            </LeftSideModal>
        )
    }
    return (
        <AdminLayout
            sidebarSlot={
            <SideBar>
                <ProjectSidebar id={projectID}/>
            </SideBar>
        }
        >
            <Button
                style={{alignSelf: "flex-end", minHeight: "50px"}}
                className='text-15 cursor-pointer normal'
                onClick={openTestRunCreationForm}
            >
                Создать тестовый прогон
            </Button>
            <FlexRow style={{"width": "100%", "height": "100%"}}>
                <TestRunsDatagrid
                    isActive={!!activeTestRun}
                    data={testRuns}
                    onRowClick={(e: React.MouseEvent<HTMLElement>)=>{
                        const id = Number((e.currentTarget as HTMLElement).id);
                        setActiveTestRun(prev => prev === id ? null : id);
                    }}
                />
                {!!activeTestRun && <TestRunDetailGrid testRunID={activeTestRun} />}
            </FlexRow>
        </AdminLayout>
    )
}

export default ProjectTestRunsManage;